import { EntityReport4det } from "../../entity/EntityReport4det";

export class DtoReport4detsDeleteRes extends EntityReport4det {
  public message: string | null = null;
}
